import { ReactNode, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import useConfig from "src/hooks/useConfig"
import useIsAuthed from "src/hooks/useIsAuthed"

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const config = useConfig()
  const [canAccess, setCanAccess] = useState(false)

  const isAuthed = useIsAuthed()
  const history = useHistory()

  useEffect(() => {
    if (
      config.endUserLogin === "loading" ||
      config.endUserRegistration === "loading"
    ) {
      return
    }
    // set unprotected if login is disabled
    if (!config.endUserLogin) {
      setCanAccess(true)
      return
    }

    setCanAccess(isAuthed)

    if (!isAuthed) {
      history.replace("/user-login")
    }
  }, [config.endUserLogin, config.endUserRegistration, isAuthed])

  if (!canAccess) return null
  return children
}

export default ProtectedRoute
